/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      helper — `(ui-is-nuova)`: true when this device renders the
 *              «UI nuova» (service:ui enabled query-only by
 *              instance-initializers/ui.js, the device unlocked with `?ui=new`,
 *              stored version 'nuova')
 *   extends:   Helper (@ember/component/helper)
 *   template:  none
 *   uses:      service:ui (beebee-base, optional lookup)
 *   siblings:  beebee-base-template helpers/ui-is-nuova.js (same helper for the
 *              apps on the shared shell; this app does not depend on
 *              beebee-base-template), apps/beebeeboard-booking
 *              helpers/ui-is-nuova.js (the copy this one comes from)
 *   tests:     tests/acceptance/ui-nuova-ecommerce-test.js
 *   gotchas:   the shop controllers (application, detail) are frozen god-files
 *              (size ratchet), so the wave-B template forks read the switch
 *              through this helper instead of a `@service ui` on a controller.
 *
 * Plan: docs/ui-nuova/MIGRATION-PLAN.md §1.2 (template switch), M18 ec-enable.
 */
import Helper from '@ember/component/helper';
import { getOwner } from '@ember/application';

export default class UiIsNuovaHelper extends Helper {
  // `ui.isNuova` is tracked (version, enabled, unlocked, tenant): reading it here
  // re-runs compute when the gate changes, e.g. when routes/application.js pushes
  // the tenant of the public shop.
  compute() {
    return Boolean(getOwner(this)?.lookup('service:ui')?.isNuova);
  }
}
